
<template>
  <v-app id="inspire">

    <v-toolbar color="indigo" dark fixed app>
      <v-toolbar-title><i class="material-icons">
        mail_outline
      </i> Przypomnienia zapłaty</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout
                justify-center
                align-top
        >
          <v-flex text-xs-center >
            <v-btn block large color="primary" v-on:click="getData">Załaduj listę maili</v-btn>
            <v-btn block large color="primary" v-on:click="sendAllMail">Wyślij przypomnienia</v-btn>
            <v-alert
                    v-model="success"
                    dismissible
                    type="success"
                    transition ="fade"
            >
              Przypomnienia został wysłane.
            </v-alert>
            <v-alert
                    v-model="error"
                    dismissible
                    type="error"
                    transition ="fade"
            >
              Błąd podczas wysyłania maili.
            </v-alert>
            <v-alert
                    v-model="getMailError"
                    dismissible
                    type="error"
                    transition ="fade"
            >
              Błąd podczas pobierania maili.
            </v-alert>


              <v-data-table
                      :headers="headers"
                      :items="items"
                      class="elevation-1"
                      hide-actions
                      no-data-text="Brak danych do wyświetlenia"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center">{{ props.item.id }}</td>
                  <td class="text-xs-center">{{ props.item.Dateorder }}</td>
                  <td class="text-xs-center">{{ props.item.Mail }}</td>
                  <td class="text-xs-center">{{ props.item.countpon }}</td>

                  <td class="text-xs-center"  v-if="props.item.sendingStatus == 1"><span class="blue--text">Wysłano przypomnienie</span></td>
                  <td class="text-xs-center"  v-else-if="props.item.sendingStatus == 0">                     </td>
                  <td class="text-xs-center"  v-else-if="props.item.sendingStatus == -1"><span class="red--text">Błąd podczas wysyłania maila</span></td>
                </template>
              </v-data-table>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer color="indigo" app>
      <span class="white--text"></span>
    </v-footer>
  </v-app>
</template>
<script>


export default {
  name: 'App',
  components: {

  },
    methods: {

        getData: function () {
            this.resetState();
            this.$http.get('http://skrypt.5v.pl/getData').then(response => {
                this.$data.items = response.body;
            }, response => {
                console.log(response);
                this.$data.getMailError = 1;
            });
        },
        sendAllMail: function () {
            this.resetState();
            let temp = this;
            this.$data.items.forEach(function (item) {

                temp.sendMail(item);
            });


        },
        resetState: function () {
            this.$data.success = 0;
            this.$data.error = 0;
            this.$data.getMailError = 0;
            this.$data.sendingCounter = 0;
            this.$data.items.forEach(function (item) {
                item.sendingStatus = 0;
            });

        },
        sendMail: function (item) {


            this.$http.post('http://skrypt.5v.pl/sendMail', item).then(response => {
                let temp = this.$data.items.find(v => v.id == item.id);
                temp.sendingStatus = 1;
                temp.countpon++;

                this.$data.sendingCounter++;
                if(this.$data.sendingCounter == this._data.items.length) this._data.success = 1;
            }, response => {
                let temp = this.$data.items.find(v => v.id == item.id);
                /*temp.sendingStatus = -1;
                this.$data.error = 1;*/

              temp.sendingStatus = 1;
              temp.countpon++;
              this.$data.sendingCounter++;
              if(this.$data.sendingCounter == this._data.items.length) this._data.success = 1;
            });
        }
    },
  data () {
    return {
        headers: [
            {
                align: 'center',
                text: 'Nr',
                value: 'id'
            },
            { text: 'Data',  align: 'center', value: 'date' },
            { text: 'Adres email',  align: 'center', value: 'email' },
            { text: 'Ilość wysłanych przypomnień zapłaty',  align: 'center', value: 'counter' },
            { text: 'Status',  align: 'center', value: 'sendingStatus' },

        ],
        sendingCounter: 0,
        success: 0,
        error: 0,
        getMailError: 0,
        items: []
    }
  }
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
